<template>
  <aside class="main-sidebar elevation-4 sidebar-light-danger">
    <a href="#" class="brand-link navbar-danger">
      <img src="./../../assets/img/white/logo-simples.png" alt="AdminLTE Logo" class="brand-image img-circle elevation-3">
      <span class="brand-text font-weight-bolder text-white">
        <img src="./../../assets/img/white/tipografia.png" height="19" />
      </span>
    </a>

    <div class="sidebar os-host os-theme-light os-host-overflow os-host-overflow-y os-host-resize-disabled os-host-scrollbar-horizontal-hidden os-host-transition">
      <div class="user-panel mt-3 pb-3 mb-3 d-flex">
        <div class="image">
          <img src="./../../assets/img/mascote.png" class="img-circle" alt="User Image">
        </div>
        <div class="info">
          <a href="#" class="d-block">{{ user.name }}</a>
        </div>
      </div>
      <nav class="mt-2">
        <ul class="nav nav-pills nav-sidebar flex-column nav-flat" data-widget="treeview" role="menu" data-accordion="false">
          <li class="nav-item has-treeview menu-open">
            <a href="#" class="nav-link">
              <i class="nav-icon fas fa-users"></i>
              <p>
                Usuários
                <i class="right fas fa-angle-left"></i>
              </p>
            </a>
            <ul class="nav nav-treeview">
              <li class="nav-item">
                <router-link to="/students" class="nav-link">
                  <i class="fas fa-user-graduate nav-icon"></i>
                  <p>Alunos</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/teachers" class="nav-link">
                  <i class="fas fa-chalkboard-teacher nav-icon"></i>
                  <p>Professores</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/admins" class="nav-link">
                  <i class="fas fa-user-shield nav-icon"></i>
                  <p>Administradores</p>
                </router-link>
              </li>
            </ul>
          </li>

          <li class="nav-item">
            <router-link to="/sells" class="nav-link">
              <i class="nav-icon fas fa-dollar-sign"></i>
              <p>
                Vendas
              </p>
            </router-link>
          </li>

          <li class="nav-item">
            <router-link to="/courses" class="nav-link">
              <i class="nav-icon fas fa-book-open"></i>
              <p>
                Cursos
              </p>
            </router-link>
          </li>

          <li class="nav-item">
            <router-link to="/doubts" class="nav-link">
              <i class="nav-icon fas fa-question-circle"></i>
              <p>
                Dúvidas
                <!-- <span class="right badge badge-danger">New</span> -->
              </p>
            </router-link>
          </li>

          <li class="nav-item">
            <router-link to="/tickets" class="nav-link">
              <i class="nav-icon fas fa-info-circle"></i>
              <p>
                Tickets
                <!-- <span class="right badge badge-danger">New</span> -->
              </p>
            </router-link>
          </li>

          <li class="nav-item">
            <router-link to="/sell-log" class="nav-link">
              <i class="nav-icon fas fa-clipboard-list"></i>
              <p>
                Log de Vendas
                <!-- <span class="right badge badge-danger">New</span> -->
              </p>
            </router-link>
          </li>
        </ul>
      </nav>
    </div>
  </aside>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      user: 'getCurrentUser'
    })
  }
}
</script>
